/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Indicateinterest_Errormessage3Inputs */

const en_coinvestments_indicateinterest_errormessage3 = /** @type {(inputs: Coinvestments_Indicateinterest_Errormessage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to submit indicative order. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to submit indicative order. Please try again." |
*
* @param {Coinvestments_Indicateinterest_Errormessage3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_indicateinterest_errormessage3 = /** @type {((inputs?: Coinvestments_Indicateinterest_Errormessage3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Indicateinterest_Errormessage3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_indicateinterest_errormessage3(inputs)
});
export { coinvestments_indicateinterest_errormessage3 as "coInvestments_indicateInterest_errorMessage" }